import { For as ChakraFor, ForProps } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Dict<T = any> = Record<string, T>;

export const For = <T extends string | number | Dict | undefined>(
  props: ForProps<T>
): ReactElement => {
  return ChakraFor(props) as ReactElement;
};
